export default {
      id: "bottom-shape-quote-usage",
      viewBox: "0 0 1243 138",
      url: "../../assets/" + "sprite.svg#bottom-shape-quote-usage",
      toString: function () {
        return this.url;
      }
    }